import {
  APICallState,
  HostInfoTypes,
  Selectors,
  UserTierTypes,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';

import VIPHostInfoHotline from 'components/VIPHostInfoHotline';

const ConnectedVIPHostInfoHotline = () => {
  const hostInfo = useWidgetState(Selectors.hostInfoSelector) as HostInfoTypes;
  const userTier = useWidgetState(Selectors.tierSelector) as UserTierTypes;
  const profileLoadState = useWidgetState(
    Selectors.mfaProfileStatusSelector,
  ) as APICallState;

  return (
    <VIPHostInfoHotline
      tier={userTier}
      hostInfo={hostInfo}
      isLoading={profileLoadState === APICallState.LOADING}
    />
  );
};

export default ConnectedVIPHostInfoHotline;
